@if (showIcon) {
    <i class="pe-1 align-self-baseline fal fa-lock-alt"></i>
}
@if (role) {
    @if (!linkDisabled) {
        <a class="btn btn-link"
           (click)="configureAccessLevel()">{{ role!.label }}</a>
    } @else {
        {{ role!.label }}
    }
}
